/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './app.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from './about/about.component.ngfactory';
import * as import3 from '../../../src/app/about/about.component';
import * as import4 from '../../../src/app/core/scroll.service';
import * as import5 from '@angular/material';
import * as import6 from '../../../src/app/core/contact.service';
import * as import7 from '../../../src/app/core/destroyer.service';
import * as import8 from './project/project.component.ngfactory';
import * as import9 from '../../../src/app/project/project.component';
import * as import10 from '../../../src/app/core/project.service';
import * as import11 from './contact/contact.component.ngfactory';
import * as import12 from '../../../src/app/contact/contact.component';
import * as import13 from '@angular/forms';
import * as import14 from '../../../src/app/app.component';
const styles_AppComponent:any[] = [import0.styles];
export const RenderType_AppComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_AppComponent,
  data: {}
}
);
export function View_AppComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'port-about',[[
        'id',
        'about'
      ]
      ],[[
        2,
        'typing-finished',
        (null as any)
      ]
    ],(null as any),(null as any),import2.View_AboutComponent_0,import2.RenderType_AboutComponent)),
    import1.ɵdid(2121728,(null as any),0,import3.AboutComponent,[
      import4.ScrollService,
      import5.MdDialog,
      import6.ContactService,
      import7.DestroyerService,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'port-project',[[
        'id',
        'projects'
      ]
      ],(null as any),[[
        'window',
        'resize'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:resize' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onResize()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_ProjectComponent_0,import8.RenderType_ProjectComponent)),
    import1.ɵdid(57344,(null as any),0,import9.ProjectComponent,[import10.ProjectService],(null as any),(null as any)),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'port-contact',[[
        'id',
        'contact'
      ]
    ],[
      [
        2,
        'open',
        (null as any)
      ]
      ,
      [
        2,
        'animating',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import11.View_ContactComponent_0,import11.RenderType_ContactComponent)),
    import1.ɵdid(57344,(null as any),0,import12.ContactComponent,[
      import13.FormBuilder,
      import6.ContactService,
      import5.MdSnackBar
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,3,0);
    ck(v,5,0);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,1).typingFinished;
    ck(v,0,0,currVal_0);
    const currVal_1:any = import1.ɵnov(v,5).open;
    const currVal_2:any = import1.ɵnov(v,5).animating;
    ck(v,4,0,currVal_1,currVal_2);
  });
}
function View_AppComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'port-app',([] as any[]),(null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
    import1.ɵdid(24576,(null as any),0,import14.AppComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const AppComponentNgFactory:import1.ComponentFactory<import14.AppComponent> = import1.ɵccf('port-app',import14.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L3BvcnRmb2xpby9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvcG9ydGZvbGlvL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L3BvcnRmb2xpby9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L3BvcnRmb2xpby9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHBvcnQtYWJvdXQgaWQ9XCJhYm91dFwiPjwvcG9ydC1hYm91dD48cG9ydC1wcm9qZWN0IGlkPVwicHJvamVjdHNcIj48L3BvcnQtcHJvamVjdD48cG9ydC1jb250YWN0IGlkPVwiY29udGFjdFwiPjwvcG9ydC1jb250YWN0PiIsIjxwb3J0LWFwcD48L3BvcnQtYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7OztJQUFBO0tBQUE7TUFBb0M7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBMkM7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7O0lBQUE7S0FBQTs7O0lBQTNDO0lBQTJDOztJQUEvRTtJQUFBLFNBQUEsU0FBQTtJQUErRTtJQUFBO0lBQUEsU0FBQSxtQkFBQTs7Ozs7SUNBL0U7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/app.component.ngfactory.ts